import axios from "axios";

export default {
  getPodium(podiumParams) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.HAUGAZEL_SERVICE_PUBLIC_PATH}/podium`,
        params: podiumParams
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getParameters() {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.HAUGAZEL_SERVICE_PUBLIC_PATH}/parameters`,
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getProduct(id, duration) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.HAUGAZEL_SERVICE_PUBLIC_PATH}/products/hgz/${id}`,
        params: {
          duration: duration,
          detailed: 1
        }
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getProductByOffer(id) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.HAUGAZEL_SERVICE_PUBLIC_PATH}/offers/${id}`,
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getTempProducts() {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.HAUGAZEL_SERVICE_PUBLIC_PATH}/products/temporary`,
        params: {
          detailed: 1
        }
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getPartner(agent) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.HAUGAZEL_SERVICE_PUBLIC_PATH}/partner`,
        params: {agent: agent}
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/haugazelService.js